import { DatePicker, Form, ModalProps, Space, Typography } from "antd";
import SimpleModal from "components/Molecules/modal/simple-modal";
import React from "react";
import moment from "moment";
import styled from "@emotion/styled";
import Select from "components/Atoms/select";
import Tag from "components/Atoms/tag";
import { useStaticRejectReasons } from "context/static-data-context";

const StyledSpace = styled(Space)`
  width: 100%;
`;
const StyledDatePicker = styled(DatePicker)`
  min-width: 80%;
`;
export const ModalComplianceReject = ({
  content,
  defaultExpiryDate,
  hideText,
  onSubmit,
  ...props
}: ModalProps & {
  content?: string | React.ReactNode;
  defaultExpiryDate?: Date;
  hideText?: boolean;
  onSubmit?: (values: any) => void;
}) => {
  const [form] = Form.useForm();
  const rejectedReasonsOptions = useStaticRejectReasons(true);
  const defaultMessage =
    "Are you sure to reject the documents? After confirmed, you can not update the";
  return (
    <SimpleModal
      title="Reject The Compliance"
      onOk={async () => {
        await form.validateFields();
        onSubmit && onSubmit(form.getFieldsValue());
      }}
      {...props}
    >
      <StyledSpace direction="vertical">
        {!hideText && (
          <Typography.Text>{content || defaultMessage}</Typography.Text>
        )}
        <Form
          form={form}
          name="compliance-rejected"
          layout="vertical"
          initialValues={{
            reason: [],
          }}
        >
          <Form.Item
            name="reason"
            label="Reject Reason"
            labelAlign="right"
            rules={[
              {
                validator: (_, value) =>
                  value && value.length
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error("Reject reason cannot be empty")
                      ),
              },
            ]}
          >
            <Select
              creatableProps={{
                isMulti: true,
                isClearable: false,
                onChange: (value: any) => {
                  form.setFields([
                    {
                      name: "reason",
                      errors: [],
                      value: value,
                    },
                  ]);
                },

                components: {
                  MultiValue: (valueProps: any) => {
                    const { data, removeProps } = valueProps;
                    return (
                      <Tag closable onClose={removeProps.onClick}>
                        {data?.label}
                      </Tag>
                    );
                  },
                },
              }}
              isCreatable
              mode="multiple"
              showArrow
              style={{ width: "100%" }}
              options={rejectedReasonsOptions as []}
            ></Select>
          </Form.Item>
        </Form>
      </StyledSpace>
    </SimpleModal>
  );
};
